import type { PrototypeVersion } from "../types";

import { AdsManagerContent } from "./AdsManagerContent";
import { OverviewTabContent } from "./overview/OverviewTabContent";

type OverviewTabProps = {
  version: PrototypeVersion;
  onOpenMonth: (monthIndex: number) => void;
};

export function OverviewTab({ version, onOpenMonth }: OverviewTabProps) {
  return (
    <AdsManagerContent className="py-8 pb-32">
      <OverviewTabContent version={version} onOpenMonth={onOpenMonth} />
    </AdsManagerContent>
  );
}
